import {Player} from '@lottiefiles/react-lottie-player';
import {fixAssetsPathForLottieImages} from 'utils/lottie';

import data from './data.json';
import img_0 from './images/img_0.png';
import img_1 from './images/img_1.png';
import img_2 from './images/img_2.png';
import img_3 from './images/img_3.png';
import img_4 from './images/img_4.png';
import img_5 from './images/img_5.png';
import img_6 from './images/img_6.png';
import img_7 from './images/img_7.png';
import img_8 from './images/img_8.png';
import img_9 from './images/img_9.png';
import img_10 from './images/img_10.png';
import img_11 from './images/img_11.png';

export const IntHeroAnimation = () => {
  /* eslint-disable @typescript-eslint/naming-convention */
  const images = {
    image_0: img_0,
    image_1: img_1,
    image_2: img_2,
    image_3: img_3,
    image_4: img_4,
    image_5: img_5,
    image_6: img_6,
    image_7: img_7,
    image_8: img_8,
    image_9: img_9,
    image_10: img_10,
    image_11: img_11,
  };
  /* eslint-enable @typescript-eslint/naming-convention */

  const amendedData = fixAssetsPathForLottieImages(data, images);

  return <Player src={amendedData} autoplay loop />;
};
